import { render, staticRenderFns } from "./SimulateTest.vue?vue&type=template&id=4eb0bf28"
import script from "./SimulateTest.vue?vue&type=script&lang=js"
export * from "./SimulateTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports